import { useState } from "react";
import { api } from "../lib/api";
import { useT } from "../i18n";

/** Botones «Excel» y «CSV» de una vista exportable (contrato con Italfarmaco, punto 13).
 *  `path` es el endpoint de exportación con los filtros de la vista, sin `format`: el fichero
 *  trae lo mismo que la pantalla. Descarga con `api.download`, que manda el token. */
export default function ExportButtons({ path, stem, small }: { path: string; stem: string; small?: boolean }) {
  const t = useT();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const go = async (format: "xlsx" | "csv") => {
    setBusy(true); setErr("");
    try {
      await api.download(`${path}${path.includes("?") ? "&" : "?"}format=${format}`, `${stem}.${format}`);
    } catch (e: unknown) {
      setErr((e as Error)?.message ?? t("export.error"));
      setTimeout(() => setErr(""), 4000);
    } finally { setBusy(false); }
  };
  const pad = small ? "5px 12px" : "7px 16px";
  return (
    <span style={{ display: "inline-flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
      <button onClick={() => go("xlsx")} disabled={busy} style={{ background: "var(--clr-org-primary)", color: "#fff", border: 0, borderRadius: 999, padding: pad, fontSize: "0.78rem", fontWeight: 600, cursor: busy ? "default" : "pointer", opacity: busy ? 0.6 : 1 }}>
        {busy ? t("export.busy") : t("export.excel")}
      </button>
      <button onClick={() => go("csv")} disabled={busy} style={{ background: "transparent", color: "var(--clr-org-primary)", border: "1px solid var(--clr-org-primary)", borderRadius: 999, padding: pad, fontSize: "0.78rem", fontWeight: 600, cursor: busy ? "default" : "pointer", opacity: busy ? 0.6 : 1 }}>
        {t("export.csv")}
      </button>
      {err && <span role="alert" style={{ color: "#dc2626", fontSize: "0.75rem" }}>{err}</span>}
    </span>
  );
}
